import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useLegalDocumentsCheck } from "@/hooks/useLegalDocumentsCheck";
import LegalAcceptanceModal from "@/components/LegalAcceptanceModal";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
  const { user, isLoading, isAdmin } = useAuth();
  const { needsAcceptance, pendingDocuments, isChecking, markAsAccepted } = useLegalDocumentsCheck();

  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground mb-2">Access Denied</h1>
          <p className="text-muted-foreground">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <LegalAcceptanceModal 
        open={needsAcceptance}
        pendingDocuments={pendingDocuments}
        onAccept={markAsAccepted} 
      />
      {children}
    </>
  );
};

export default ProtectedRoute;